import { ComponentButton } from './ComponentButton';
import { ActionButton as ActionButtonType } from '@/schemas/sceneDataSchema';
import { useAction } from '@/hooks/use-action';
import { RouteFn } from '@/hooks/use-flow';
import useToast from '@/hooks/use-toasts';
import useAnalytics, { eventName } from '@/hooks/use-analytics';

export const ActionButton = ({ component, route }: { component: ActionButtonType; route: RouteFn }) => {
  const { executeAction, isLoading } = useAction();
  const { trackClick } = useAnalytics();

  const { getToast } = useToast();
  const successToast = getToast(component.success_toast_id ?? '');
  const errorToast = getToast(component.error_toast_id ?? '');

  const onClick = () => {
    trackClick(eventName(component.id), { action: component.action, button_type: component.type });
    executeAction(component.action, component.arguments ?? {}, route)
      .then(() => {
        if (successToast) {
          successToast.open();
        }
      })
      .catch(() => {
        if (errorToast) {
          errorToast.open();
        }
      });
  };

  return (
    <ComponentButton
      onClick={onClick}
      component={component}
      type='button'
      loading={isLoading}
    />
  );
};
